import PurchaseCard from './PurchaseCard';

export default PurchaseCard;
